import { render } from "./AdminInvoicing.vue?vue&type=template&id=ff65e642&scoped=true"
import script from "./AdminInvoicing.vue?vue&type=script&lang=js"
export * from "./AdminInvoicing.vue?vue&type=script&lang=js"

import "./AdminInvoicing.vue?vue&type=style&index=0&id=ff65e642&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff65e642"]])

export default __exports__